if (!customElements.get('nuer-coupon-popup')) {
  customElements.define('nuer-coupon-popup', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.dialog = this.querySelector('dialog');
      if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
      this.key = `nuer-coupon-seen:${this.dataset.code}`;
      if (this.seen()) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.dialog.addEventListener('close', () => document.body.classList.remove('nuer-coupon-open'), options);
      this.dialog.addEventListener('click', (event) => {
        if (event.target !== this.dialog) return;
        const bounds = this.dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.dialog.close();
      }, options);
      this.querySelector('[data-copy]').addEventListener('click', async () => {
        const status = this.querySelector('[data-status]');
        try {
          await navigator.clipboard.writeText(this.dataset.code);
          status.textContent = status.dataset.success;
        } catch {
          status.textContent = status.dataset.error;
        }
      }, options);
      this.timer = setTimeout(() => this.open(), Math.max(0, Number(this.dataset.delay) || 0));
    }

    seen() {
      if (window.nuerCouponSeen?.has(this.key)) return true;
      try {
        return sessionStorage.getItem(this.key) === '1';
      } catch {
        return false;
      }
    }

    open() {
      if (!this.isConnected || this.seen()) return;
      const busy = document.querySelector('dialog[open], modal-dialog[open], .drawer.active, details[open] > .menu-drawer');
      if (document.visibilityState !== 'visible' || busy) {
        this.timer = setTimeout(() => this.open(), 1000);
        return;
      }
      this.dialog.showModal();
      document.body.classList.add('nuer-coupon-open');
      window.nuerCouponSeen ??= new Set();
      window.nuerCouponSeen.add(this.key);
      try {
        sessionStorage.setItem(this.key, '1');
      } catch {}
    }

    disconnectedCallback() {
      clearTimeout(this.timer);
      if (this.dialog?.open) {
        this.dialog.close();
        document.body.classList.remove('nuer-coupon-open');
      }
      this.controller?.abort();
      this.controller = null;
    }
  });
}
